import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AirtimePlanDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchAirtimePlans } from "../../../../features/auth/store/airtimePlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import AirtimePlans from "./Airtime";
import { fetchAirtimeCategories } from "../../../../features/auth/store/airtimeCategorySlice";
import { fetchCountries } from "../../../../features/auth/store/countrySlice";
import { SortBy, SortOrder } from "../../../../features/auth/store/types/types";

const AirtimePlanRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [categoryFilter, setCategoryFilter] = useState<string>("");
  const [countryFilter, setCountryFilter] = useState<string>("");
  const [sortBy, setSortBy] = useState<SortBy | "">("created_at");
  const [sortOrder, setSortOrder] = useState<SortOrder | "">("desc");
  const [selectedAirtimePlan, setSelectedAirtimePlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { airtimePlans, loading, error } = useSelector(
    (state: RootState) => state.airtimePlans,
  );

  const { airtimeCategories } = useSelector(
    (state: RootState) => state.airtimeCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (!airtimeCategories || airtimeCategories.length === 0) {
      dispatch(fetchAirtimeCategories({ perPage: 100 }));
    }
    dispatch(fetchCountries({ page: 1, perPage: 100 }));
  }, [dispatch]);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchAirtimePlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (categoryFilter) filters.category = categoryFilter; // ID sent
      if (countryFilter) filters.country = countryFilter; // ID sent
      if (sortBy) filters.sort_by = sortBy;
      if (sortOrder) filters.sort_order = sortOrder;
      if (searchTerm.trim()) filters.search = searchTerm.trim();

      dispatch(fetchAirtimePlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [
    dispatch,
    statusFilter,
    categoryFilter,
    countryFilter,
    sortBy,
    sortOrder,
    searchTerm,
  ]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleAirtimePlanClick = (airtimePlan: Product) => {
    setSelectedAirtimePlan(airtimePlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedAirtimePlan(null);
  };

  if (showDetailView && selectedAirtimePlan) {
    return (
      <AirtimePlanDetailView
        airtimePlan={{
          ...selectedAirtimePlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <AirtimePlans
      airtimePlans={airtimePlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onAirtimePlanClick={handleAirtimePlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      categoryFilter={categoryFilter}
      setCategoryFilter={setCategoryFilter}
      countryFilter={countryFilter}
      setCountryFilter={setCountryFilter}
      sortBy={sortBy}
      setSortBy={setSortBy}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
    />
  );
};

export default AirtimePlanRouter;
